import { ShieldCheck, FlaskConical, Gauge, PackageCheck, ScanSearch } from "lucide-react";
import { Reveal, SectionHead } from "../site/Motion";
import { useSettings } from "../../lib/api";

const QA = [
  [ScanSearch, "Raw material inspection", "Incoming polymer and chemicals checked against specification."],
  [FlaskConical, "Compound control", "Batch-wise testing of compound properties before molding."],
  [Gauge, "In-process checks", "Dimensional and hardness checks during production runs."],
  [ShieldCheck, "Final inspection", "Visual and dimensional inspection against drawing."],
  [PackageCheck, "Traceable dispatch", "Lot-wise packing and labelling for traceability."],
];

export const Quality = () => {
  const s = useSettings();
  const certs = Array.isArray(s.certifications) ? s.certifications : [];
  return (
    <section id="quality" data-testid="quality-iso-section" className="bg-slate-50 py-24 md:py-32">
      <div className="container-x grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHead eyebrow="04 — Certifications & quality" title={<>Zero guesswork. <span className="text-[#0a6cff]">Every lot.</span></>}>
            Quality is built into the process, not inspected at the end. Every order moves through a documented five-stage QA path.
          </SectionHead>
          <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
            {certs.map((c, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div data-testid={`iso-badge-${i}`} className="flex items-center gap-5 border border-slate-200 bg-white p-5 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#0a6cff]">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-[#0a6cff] text-[#0a6cff]">
                    <ShieldCheck className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="font-display text-2xl font-extrabold uppercase text-slate-950">{c?.title}</p>
                    <p className="text-xs text-slate-500">{c?.subtitle}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <ol data-testid="qa-process-steps" className="relative lg:col-span-7">
          <span className="absolute bottom-6 left-[27px] top-6 w-px bg-gradient-to-b from-[#0a6cff] via-slate-300 to-transparent" />
          {QA.map(([Icon, t, d], i) => (
            <Reveal as="li" key={t} delay={i * 0.07} className="relative flex gap-6 pb-10 last:pb-0">
              <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center bg-[#07090e] text-sky-400">
                <Icon className="h-5 w-5" />
              </span>
              <div className="border-b border-slate-200 pb-8">
                <p className="font-mono-x text-xs text-[#0a6cff]">STAGE 0{i + 1}</p>
                <h3 className="font-display mt-1 text-3xl font-extrabold uppercase text-slate-950">{t}</h3>
                <p className="mt-2 text-sm text-slate-600">{d}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
